import { createContext, Dispatch, SetStateAction, use } from 'react'
import { StandardInputType } from '@/types'

interface RowContextType<T extends StandardInputType> {
  rowType: T
  setRowType: Dispatch<SetStateAction<T>>
}

const RowWithInputTypeContext = createContext<RowContextType<StandardInputType>>({
  rowType: `absolute`,
  setRowType: () => {}
})

export interface RowWithInputTypeProviderProps<T extends StandardInputType> {
  children: React.ReactNode
  defaultType: T
}

const RowWithInputTypeProvider = RowWithInputTypeContext.Provider

export const useRowWithInputTypeContext = () => use(RowWithInputTypeContext)

export { RowWithInputTypeContext, RowWithInputTypeProvider }
